import * as React from "react"

const ErrorMessage = ({ message }) => {
  return <span className="text-red text-xs">{message}</span>
}

ErrorMessage.defaultProps = {
  message: "This field is required",
}

export default ErrorMessage
